import React, { Component } from 'react';
import commonUtil from './../../../../../../utils/commonUtil';
/* import ImageSelector from '../../../../../../components/ZUILib/ImageSelector'; */
import TextInput from '../../../../../../components/ZUILib/TextInput';
import InputButton from '../../../../../../components/ZUILib/InputButton';
import KalturaFileUpload from '../../../../../../components/KalturaFileUpload';
import Warning from '../../../../../../components/Warning';
import * as eventDetailsActions from '../actions';
import * as defaultConst from './../../../../../../utils/clientConstant';

const { saveEventName } = eventDetailsActions;

export default class EditEventInfo extends Component {
  constructor(props) {
    super(props);
    this.warningMessage = '';
  }
  state = {
    eventName: '',
    _EventName: '',
    imagePath: '',
  }

  setValue = (field, e) => {
    switch (field) {
      case 'eventName':
        return this.setState({
          ...this.state,
          eventName: e,
        },
        );
      case 'image':
        return this.setState({
          ...this.state,
          imagePath: e,
        },
        );
      default: break;
    }
    return this.state;
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.eventDetailsInfo.eventName) {
      this.newEventName = nextProps.eventDetailsInfo.eventName;
    }
  }
  _keepCopyOfTemproryName = (tempEventName) => {
    let eventName = tempEventName.target.value;
    eventName = eventName.replace(/[^a-zA-z0-9ñÑ\s]/gi, '');
    this.newEventName = eventName;
    this.eventName.setValue(eventName);
  }
  /* updateEventName = () => {
     if (this.newEventName && this.newEventName !== this.props.eventDetailsInfo.eventName) {
       const eventNameValidationRules = [
         { functionRef: commonUtil.validateName, funcData: [this.newEventName, 3], errorMessage: 'El nombre del evento no es válido' },
       ];
       const validEventName = commonUtil.validateTextInput(eventNameValidationRules, this.eventName, null);
       if (validEventName) {
         this.props.handleValidateEventName(this.newEventName, this.email, '').then((response) => {
           if (response.body.status.status === defaultConst.constAPISuccess) {
             this.props.handleSaveEventNickName(this.props.eventDetailsInfo.eventId, this.newEventName);
             this.warning.setMessage('');
           } else {
             this.warning.setMessage(response.body.status.errorMessage);
           }
         });
       }
     } else {
       const eventNameValidationRulesForEmpty = [
         { functionRef: commonUtil.isValueAvailable, funcData: [this.newEventName], errorMessage: 'El nombre del evento es obligatorio' },
       ];
       const validEventNameForEmpty = commonUtil.validateTextInput(eventNameValidationRulesForEmpty, this.eventName, null);
       if (validEventNameForEmpty) {
         this.props.handleSaveEventNickName(this.props.eventDetailsInfo.eventId, this.newEventName);
         this.newEventName = '';
       }
     }
   } */
  updateEventName = () => {
    if (this.newEventName && this.newEventName !== this.props.userEventDetails.eventDetailsInfo.eventName) {
      this.props.handleValidateEventName(this.newEventName, this.email, '').then((response) => {
        if (response.body.status.status === defaultConst.constAPISuccess) {
          this.props.handleSaveEventNickName(this.props.userEventDetails.eventDetailsInfo.eventId, this.newEventName);
          this.newEventName = '';
          this.warning.setMessage('');
        } else {
          this.warning.setMessage(response.body.status.errorMessage);
        }
      });
    } else if (this.newEventName && this.newEventName === this.props.userEventDetails.eventDetailsInfo.eventName) {
      saveEventName(this.props.userEventDetails.eventDetailsInfo.eventId, this.props.userEventDetails.eventDetailsInfo.eventName).then((response) => {
        if (response.body.status.status === defaultConst.constAPIFailure) {
          this.warning.setMessage(response.body.status.errorMessage);
        }
      });
    } else {
      const eventNameValidationRulesForEmpty = [
        { functionRef: commonUtil.isValueAvailable, funcData: [this.newEventName], errorMessage: 'El nombre del evento es obligatorio' },
      ];
      const validEventNameForEmpty = commonUtil.validateTextInput(eventNameValidationRulesForEmpty, this.eventName, null);
      if (validEventNameForEmpty) {
        this.props.handleSaveEventNickName(this.props.userEventDetails.eventDetailsInfo.eventId, this.newEventName);
        this.newEventName = '';
      }
    }
  }
  componentDidMount() {
    if (document.querySelector('.file-upload')) {
      document.querySelector('.file-upload').style.display = 'none';
    }
  }

  // image upload functions
  onFileRemoved = () => {
  };
  onError = () => {
  };
  onFileSuccess = (data) => {
    document.querySelector('#item-img-output').src = data.dataUrl;
    const imageURL = data.dataUrl;
    saveEventName(this.props.eventID, '', imageURL).then((response) => {
      if (response.body.status.status === defaultConst.constAPISuccess) {
        this.warning.setMessage('');
        const box = document.querySelector('.editEventName');
        let winWidth = window.innerWidth;
        box.style.left = winWidth + 'px';
        winWidth += 1;
        box.style.left = winWidth + 'px';
        this.props._getEventDetails(this.props.eventID);
      }
    }).catch((e) => {
      console.log(e); // console required
    });
  }
  onMaxFileSizeErrorCallback = () => {
    this.warning.setMessage('Tamaño de archivo entre 128 kb a 3 MB');
  }
  onMinFileSizeErrorCallback = () => {
    this.warning.setMessage('Tamaño de archivo entre 128 kb a 3 MB');
  }
  onFileAddedError = () => {
    this.warning.setMessage('Este archivo de extensión no está permitido.');
  }
  openProfileImageUploader = () => {
    if (document.querySelector('.file-upload')) {
      document.querySelector('.file-upload').click();
    }
  }

  render() {
    const { eventDetailsInfo } = this.props;
    const eventStatusForSuspended = this.props.eventStatusForSuspended;

    let imageUrl = '';
    if (eventDetailsInfo.imageURL) {
      imageUrl = eventDetailsInfo.imageURL;
    } else {
      imageUrl = commonUtil.getAssetURL() + '/images/addImageIcon.svg';
    }
     // logic for owner email for validate ebvent name.
    eventDetailsInfo.celebrityInfo.map((data) => {
      if (data.iscoOwner === 'false') {
        this.email = data.email;
      } return false;
    });

    // for sliding effect
    this.windwidth = '';
    this.windwidth = window.innerWidth;
    const style1 = {
      left: this.windwidth,
    };
    const editAdminEventInfoButtonAttr = {
      type: 'button',
      value: 'Guardar',
      autoFocus: false,
      style: 'btnPrimaryAction',
      onClickHandler: this.updateEventName,
    };

    return (
      <div className="myEventContent editEventName" style={style1} >
        {/* <div className="myEventContent" style={style1} > */}
        <div className="row">
          <div className="col-xs-12">
            <h1 className="noBorder">Datos de mi evento</h1>
          </div>
        </div>
        <div className="row editEventInfo">
          <form onSubmit={(e) => { e.preventDefault(); }}>
            <div className="col-xs-12">
              <div className="imageWrapper">
                <img id="item-img-output" src={imageUrl} alt="Agregar Archivo" onClick={this.openProfileImageUploader} />
                <label className="uploadIcon"><label className="iClass icon-camara" /></label>
              </div>
              {/* <div className="actionUpload">
                <KalturaFileUpload onFileSuccess={this.onFileSuccess} fileAccept="image/*" textLabel={'Elegir imagen'} onFileAddedError={this.onFileAddedError} onMaxFileSizeErrorCallback={this.onMaxFileSizeErrorCallback} onMinFileSizeErrorCallback={this.onMinFileSizeErrorCallback} />
              </div> */}
              {eventStatusForSuspended === true ? null :
              <div className="actionUpload">
                <KalturaFileUpload onFileSuccess={this.onFileSuccess} fileAccept="image/*" onFileAddedError={this.onFileAddedError} onMaxFileSizeErrorCallback={this.onMaxFileSizeErrorCallback} onMinFileSizeErrorCallback={this.onMinFileSizeErrorCallback} />
              </div>
          }
            </div>
            <Warning type="error" text={this.warningMessage} ref={warning => this.warning = warning} />
            <div className="col-xs-12">
              <p>Nombre del evento:</p>
              {/* {eventDetailsInfo.eventName ? <h3>{commonUtil.sentenceCase(eventDetailsInfo.eventName)}</h3> : null} */}
              {eventDetailsInfo.eventName ? <h3>{eventDetailsInfo.eventName}</h3> : null}
              <div className="formBlock">
                <TextInput
                  className="inputMaterial"
                  labelClassName="placeHolderMaterial"
                  htmlId="eventName"
                  label="Nombre del evento"
                  name="Nombre del evento"
                  required="true"
                  maxlength="30"
                  value={eventDetailsInfo.eventName}
                  onChange={e => this._keepCopyOfTemproryName(e)}
                  ref={el => (this.eventName = el)}
                  disabled={eventStatusForSuspended && 'disabled'}
                />
              </div>
              {eventStatusForSuspended ? null : <InputButton buttonAttr={editAdminEventInfoButtonAttr} />}
            </div>
          </form>

          <div className="eventMoreInfo">
            <div className="col-xs-12">
              <p className="label">Fecha del evento:</p>
              <span className="date">{eventDetailsInfo.eventDate}</span>
              <p className="label">Número del evento:</p>
              <span className="id">{eventDetailsInfo.eventId}</span>
              {eventDetailsInfo.eventType ?
                <React.Fragment>
                  <p className="label">Tipo de evento:</p>
                  <span className="type">{commonUtil.sentenceCase(eventDetailsInfo.eventType)}</span>
                </React.Fragment>
                : null}
            </div>
          </div>

        </div>
      </div>
    );
  }
}
